import React from "react";
import { Helmet } from "react-helmet";

import BannerSponsorship from "components/Sponsorship/BannerSponsorship";
import SponsorshipAdvice from "components/Sponsorship/SponsorshipAdvice";
import SectionObjectives from "components/Sponsorship/SectionObjectives";
import SectionPrinciples from "components/Sponsorship/SectionPrinciples";
import SectionSponsorshipPolicy from "components/Sponsorship/SectionSponsorshipPolicy/SectionSponsorshipPolicy";
import SectionSupportedInitiatives from "components/Sponsorship/SectionSupportedInitiatives";

const Sponsorship = () => {
  return (
    <>
      <Helmet>
        <title>CNP Seguros Holding Brasil | Patrocínios</title>
        <meta
          name="description"
          content="A CNP Seguros Holding Brasil é a 3a maior seguradora do país e faz parte de um grupo com atuação global, presente em diversos países do mundo."
        />
        <meta
          name="keywords"
          content="CNP Seguros, Holding, seguradora, global, CNP Assurances, CNP Seguros Holding Brasil, CNP no Brasil, parceria"
        />
      </Helmet>

      <BannerSponsorship />
      <SponsorshipAdvice />
      <SectionPrinciples />
      <SectionObjectives />
      <SectionSupportedInitiatives />
      <SectionSponsorshipPolicy />
    </>
  );
};

export default Sponsorship;
